import moment from "moment";
import React from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
export default class RequestsListComponent extends React.Component {
  constructor(props) {
    super(props);
    const {t} = props
    this.state = {
      tooltipText: <Tooltip id="tooltip">{t('revisedCost')}</Tooltip>,
      attachmentText: <Tooltip id="tooltip">{t('costPhotoExist')}</Tooltip>
    }
  }
  render() {
    var { user, data, infoButton, exchangeRateButton, buttonsActions, costPhoto } = this.props;
    if (!data.revisions)
      data.revisions = []
    if (!data.costPhotos)
      data.costPhotos = []

    const groupId = data.invoiceNo;
    return (
      <tr>
        <td>{data.revisions.length > 0 ?
        <OverlayTrigger placement="bottom" overlay={this.state.tooltipText}>
          <i id={"accountingCostListCostSublistButton-" + groupId} className="fa fa-star star-color" aria-hidden="true"></i>
        </OverlayTrigger> : null}
          {data.costPhotos.length > 0 ?
            <OverlayTrigger placement="bottom" overlay={this.state.attachmentText}>
              <i className="fa fa-paperclip star-color" aria-hidden="true"></i>
            </OverlayTrigger>
            :
            null
          }
          {user.employees.employeeName}</td>
        <td id={"accountingCostListCostInvoiceNo-" + groupId}>{data.invoiceNo}</td>
        <td id={"accountingCostListCostCostType-" + groupId}>{data.costType}</td>
        <td id={"accountingCostListCostCostDate-" + groupId}>{
                 moment(data.costDate).format('DD/MM/YYYY')
        }</td>
        <td id={"accountingCostListCostCostCreatedDate-" + groupId}>{data.costCreatedDate}</td>
        <td id={"accountingCostListCostCostAmount-" + groupId}>{data.costAmount} {new window.Money(data.moneyType).getMoneySymbol()}</td>
        <td>
          <button type="button" id={"accountingCostListCostInfoButton-" + groupId}  onClick={() => { infoButton(user, data) }} className="btn btn-wd btn-info btn-fill btn-rotate actionBtn"><span className="btn-label"><i className="fa fa-info"></i></span></button>
          &nbsp;
          {
            data.status == "accounting"
              ?
              
              <div style={{ display: "inline-block" }}>
                <button type="button" id={"accountingCostListCostSuccessButton-" + groupId} onClick={() => { buttonsActions[0](false, user, data) }} className="btn btn-wd btn-success actionBtn"><span className="btn-label"><i className="fa fa-check"></i></span></button>
              &nbsp;
              <button type="button" id={"accountingCostListCostDangerButton-" + groupId} onClick={() => { buttonsActions[1](user, data) }} className="btn btn-wd btn-danger actionBtn"><span className="btn-label"><i className="fa fa-times"></i></span></button>
              &nbsp;             
             </div>
              :
              null
          }
          {
            data.transactions
              ?
              <span>
                <button type="button" id={"accountingCostListCostTransactionButton-" + groupId} onClick={() => { this.props.transactionsButton(user, data) }} className="btn btn-wd btn-default actionBtn"><span className="btn-label"><i className="fa fa-cogs"></i></span></button>
              &nbsp;
            </span>
              :
              null
          }           
          {
            data.exchangeRate ? 
            <button type="button"  className="btn btn-wd btn-success actionBtn" onClick={() => { exchangeRateButton(user, data) }}>
              <i
                className="fa fa-money"
              />
            </button>
            :
             null}
        </td>
      </tr >
    )
  }
}
